import { render, staticRenderFns } from "./tableRender.vue?vue&type=template&id=60a07c98&scoped=true"
import script from "./tableRender.vue?vue&type=script&lang=js"
export * from "./tableRender.vue?vue&type=script&lang=js"
import style0 from "./tableRender.vue?vue&type=style&index=0&id=60a07c98&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a07c98",
  null
  
)

export default component.exports